import { getConnections } from '@/stores/connections'
import { useSelector } from '@/stores/hooks'
import { useLoadConnectionsByArea } from '../load/useLoadConnectionsByArea'

export function useDataConnectionsByArea(
	area: string,
	{ level = 0 }: { level?: number } = {},
) {
	const load = useLoadConnectionsByArea(area, {
		level,
	})
	const connectionsByArea = useSelector(state => getConnections(state, area))
	return { ...load, connectionsByArea }
}
